module.exports = __webpack_public_path__ + "static/element_contact1-2059fe37e0a0c80c404b8cbcede26783.svg";